import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsToggle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSettingsToggle1"><Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 8.13401 4.13401 5 8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12ZM12.25 12C12.25 9.92893 13.9289 8.25 16 8.25C18.0711 8.25 19.75 9.92893 19.75 12C19.75 14.0711 18.0711 15.75 16 15.75C13.9289 15.75 12.25 14.0711 12.25 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsToggle1;
